import { safeLocalStorage } from 'utils/storage';

export const getZenModeSetting = (): boolean | null => {
  const saved = safeLocalStorage.getItem('savedZenModeSetting');
  return saved === null ? null : saved === 'true';
};

export const setZenModeSetting = (checked: boolean) => {
  safeLocalStorage.setItem('savedZenModeSetting', `${!checked}`);
};
